import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { apiRequest } from '../../store/allApi'
import { useLocation } from 'react-router-dom/cjs/react-router-dom';

export default function UpdatePassword() {

    const history = useHistory()
      const location = useLocation();
        const path = location.pathname.split("/")[3];

    const [newPassword, setNewPassword] = useState()
    const [confirmNewPassword, setCPassword] = useState()

    const addAdmin = async (e) => {

        e.preventDefault();

        const access_token = localStorage.getItem("token")

        const headers = {
            Authorization: `Bearer ${access_token}`
        }

        if (newPassword !== confirmNewPassword) {
            alert("Passwords don't match");
        } else {
            try {
                const res = await apiRequest(`changepassword/${path}`, "POST", {
                    newPassword,
                    confirmNewPassword,
                }, headers)
                if (res) {
                    history.push("/admin/alladmins")
                }
            } catch (error) {
                console.error("Error updating password:", error);
            }
        }
    }

    return (
        <div>
            <h4 className='text-uppercase font-weight-bold my-3'>Update Admin Passowrd</h4>

            <form id="add_admin_form" onSubmit={(e) => addAdmin(e)}>
                <div className="form-row">
                    <div className="form-group col-md-4">
                        <label htmlFor="passowrd">New Password</label>
                        <input type="password" className="form-control" id="password" name="password" placeholder="Passowrd" onChange={(e) => {
                            setNewPassword(e.target.value)
                        }} required />
                    </div>

                </div>
                <div className="form-row">
                    <div className="form-group col-md-4">
                        <label htmlFor="passowrd">cPassword</label>
                        <input type="password" className="form-control" id="password" name="password" placeholder="Passowrd" onChange={(e) => {
                            setCPassword(e.target.value)
                        }} required />
                    </div>

                </div>
                <div>
                    <button type="submit" className='btn  btn-success' >update</button>
                </div>
            </form>

        </div>
    )
}
